import { parameters } from '../../constants/parameters';
import * as genericApi from './generic-api';
import { UsageReport } from '../../entities/usage-report';
import { PressreleaseStatsReport } from '../../entities/pressrelease-stats-report';

export const getUsageReport = async (token: string, params?: object): Promise<UsageReport> => {
  const url = `${parameters.api.baseUrl}/reports/usage`;

  return genericApi.one<UsageReport>(token, url, params);
};

export const exportUsageReport = async (token: string, params?: object): Promise<Blob> => {
  const url = `${parameters.api.baseUrl}/reports/usage/export`;

  return genericApi.blob(token, url, params);
};

export const getPressreleaseStatsReport = async (token: string): Promise<PressreleaseStatsReport> => {
  const url = `${parameters.api.baseUrl}/reports/pressrelease-stats`;

  return genericApi.one<PressreleaseStatsReport>(token, url);
};

export const exportPressreleaseStatsReport = async (token: string): Promise<Blob> => {
  const url = `${parameters.api.baseUrl}/reports/pressrelease-stats/export`;

  return genericApi.blob(token, url);
};
